import ValidationResult from "domain/types/global/validationResult";

export const CONFIRMAR_SENHA_VALIDAR = 'CONFIRMAR_SENHA_VALIDAR'
export const CONFIRMAR_SENHA = 'CONFIRMAR_SENHA'

export interface ConfirmarSenhaState {
    tokenValid: boolean | null;
    success: ValidationResult | null;
}

export interface ValidarTokenAction {
    type: typeof CONFIRMAR_SENHA_VALIDAR;
    payload: boolean | null;
}

export interface ConfirmarSenhaAction {
    type: typeof CONFIRMAR_SENHA;
    payload: ValidationResult
}

export type ConfirmarSenhaActionTypes = ValidarTokenAction | ConfirmarSenhaAction
